/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaEventHandler.on('moya.tinymce.preInit', function (e) {
        if (document.body.classList.contains('magazine')) {
            var magazinescss = '/static/themes/2019/magazine.css?v=' + document.body.dataset.staticVersion;
            e.settings.content_css = '/_w/tinymce/content.css,' + magazinescss;
        }
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
